import { getAllLocalizedVersionsOfRoute } from 'utils/routing';

export const routesWithoutMobileHeader = [...getAllLocalizedVersionsOfRoute('hockeyChallenge')];
export const iconVariant = 'cancel';
